import { Router } from 'express';
import { TagService } from '../services/tag-service.js';
import { ApiError } from '../types.js';

export const tagRouter = Router();
const tagService = new TagService();

// 获取所有标签
tagRouter.get('/', async (req, res, next) => {
  try {
    const tags = await tagService.list();
    res.success(tags);
  } catch (error) {
    next(error);
  }
});

// 获取单个标签
tagRouter.get('/:id', async (req, res, next) => {
  try {
    const tag = await tagService.get(req.params.id);
    if (!tag) {
      throw new ApiError(404, 'Tag not found');
    }
    res.success(tag);
  } catch (error) {
    next(error);
  }
});

// 创建标签
tagRouter.post('/', async (req, res, next) => {
  try {
    const { name, category, color, description } = req.body;
    
    if (!name || !category || !color) {
      throw new ApiError(400, 'Name, category and color are required');
    }

    const tag = await tagService.create({
      name,
      category,
      color,
      description
    });
    
    res.created(tag);
  } catch (error) {
    if (error instanceof Error && error.message === '标签名称已存在') {
      next(new ApiError(409, error.message));
    } else {
      next(error);
    }
  }
});

// 更新标签
tagRouter.put('/:id', async (req, res, next) => {
  try {
    const { name, category, color, description } = req.body;
    
    const updates: any = {};
    if (name !== undefined) updates.name = name;
    if (category !== undefined) updates.category = category;
    if (color !== undefined) updates.color = color;
    if (description !== undefined) updates.description = description;

    const tag = await tagService.update(req.params.id, updates);
    res.success(tag);
  } catch (error) {
    if (error instanceof Error) {
      if (error.message === '标签不存在') {
        next(new ApiError(404, error.message));
      } else if (error.message === '标签名称已存在') {
        next(new ApiError(409, error.message));
      } else {
        next(error);
      }
    } else {
      next(error);
    }
  }
});

// 删除标签
tagRouter.delete('/:id', async (req, res, next) => {
  try {
    await tagService.delete(req.params.id);
    res.deleted();
  } catch (error) {
    if (error instanceof Error && error.message === '标签不存在') {
      next(new ApiError(404, error.message));
    } else {
      next(error);
    }
  }
});